import {Component} from '@angular/core';
import {FieldWrapper} from '@ngx-formly/core';

@Component({
  selector: 'app-col-card-wrapper',
  templateUrl: './col-card-wrapper.component.html',
  styleUrls: ['./col-card-wrapper.component.scss']
})
export class ColCardWrapperComponent extends FieldWrapper {


  getLabel() {
    return this.to.label;
  }

  getCardWrapperClass() {
    return this.to.className;
  }

  getLink(): any {
    if (this.to.linkLabel && this.to.link) {
      return {
        label: this.to.linkLabel,
        link: this.to.link
      };
    }
    return false;
  }

  getButton(): any {
    if (this.to.buttonLabel && this.to.onButtonClick) {
      return {
        label: this.to.buttonLabel,
        onClick: this.to.onButtonClick
      };
    }
    return false;
  }
}
